<template>
  <TransactionTemplate
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="false"
    :backButtonRoute="backButtonRoute"
    ref="customer-credit"
    :data-model="dataModel"
    :backRouteAppend="baseView.mode != 'review' ? undefined : 'CustomerCode'"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :headerScreenJson="getHeaderScreenJson"
    :serverError="serverError"
    :refreshDataGridProp="refreshDataGrid"
    :paging="false"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  getDefaultCustomerSettings,
  getDefaultUserSettings,
  getFactorByCode,
} from "../../_store/helpers";
import { BranchService } from "../../_services/api/sales/branch.service";
import { DivisionService } from "../../_services/api/sales/division.service";
// import { UserService } from "../../_services/api/settings/user/user.service";
import { FeatureStorage } from "../../_services/storage";
import { SalesRepresentativeService } from "../../_services/api/sales/sales-rep.service";
import salesFormulas from "../../_helpers/formulas/sales-formulas";
import { ForeignCurrencyService } from "../../_services/api/settings/accounting/foreign-currency.service";
import { CustomerDeliveryAddressService } from "../../_services/api/customers/customer-delivery-address.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerCreditService } from "../../_services/api/customers/customer-credit.service";
import { mapGetters } from "vuex";
import { TransactionService } from "../../_services/api/templates/transactions.services";
import { TaxCategoryService } from "../../_services/api/settings/accounting/tax-category.service";
import ArrayStore from "devextreme/data/array_store";
import { PurchaseOrder } from "../../_services/api/purchasing/purchase-order.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

const {
  // calculateGrossProfitPcnt,
  // calculateSalesUMPriceForGP,
  calculateNetLineTotal,
  calculateWetLineTotal,
  calculateTaxableLineTotal,
  calculateTaxLineTotal,
  calculateLineTotal,
  calculateSalesUMNetFXPrice,
  calculateStockUMPrice,
  calculateStockUMNetPrice,
  calculateStockUMFXPrice,
  calculateStockUMQty,
  calculateStockUMNetFXPrice,
  calculateDiscLineTotal,
  calculateDiscFXLineTotal,
  calculateNetFXLineTotal,
  calculateWetFXLineTotal,
  calculateTaxableFXLineTotal,
  calculateTaxFXLineTotal,
  calculateFXLineTotal,
  calculateSalesUMNetPriceFromSalesUMNetFXPrice,
  calculateSalesUMPriceFromSalesUMFXPrice,
  // calculateCalculatedDiscPcnt,
  // calculateSalesUMNetFXPriceFromSalesUMFXPrice,
  calculateSalesUMFXPrice,
  // calculateSalesUMFXPriceFromSalesUMNetFXPrice,
  calculateStockUMStandardPrice,
  // calculateSalesUMStandardPrice,
} = salesFormulas;

var glItemBase = {
  BranchCode: undefined,
  BranchDescription: undefined,
  DivisionCode: undefined,
  DivisionDescription: undefined,
  RequiredByDate: new Date(),
  ETADate: undefined,
  SupplierUM: "Ea",
  SupplierRequired: 0,
  SupplierReceivedQty: 0,
  IsBatchProduct: "No",
  SupplierFXPrice: 0,
  ItemCode: undefined,
  ItemDescription: undefined,
  ItemType: "G",
  LineType: "G",
  LineNo: 0,
  SupplierConversion: 1,
  SupplierPrice: 0,
  IsVariable: "N",
  FXPrice: 0,
  FXAmount: 0,
  TaxCode: "G",
  TaxPcnt: 10,
  TaxRate: 10,
  WetPcnt: 0,
  GoodsInCode: 0,
  FXLineTotal: 0,
  TaxFXLineTotal: 0,
  TaxableFXLineTotal: 0,
  FXTotal: 0,
  TotalWithTax: 0,
  Comment: undefined,

  // additional fields
  ComputedStringCode: undefined,
  SalesUMCreditQty: 0,
  SalesUMNetFXPrice: 0,
  TaxFXTotal: 0,
  TaxableFXTotal: 0,
};

let deliveryAddressDataSourceItems = [];

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      headerFormToolbarIntance: undefined,
      CheckStockWriteOff: false,
      loaded: false,
      setLoading: false,
      headerEndpoint: undefined,
      defaultBranchCode: undefined,
      defaultDivisionCode: undefined,
      defaultOrderTypeCode: undefined,
      defaultSalesRepCode: undefined,
      dataModel: {
        CustomerCode: undefined,
      },
      defaultTaxCode: undefined,
      taxData: {
        SalesTaxPcnt: undefined,
        WetRate: undefined,
      },
      taxDataSourceItems: [],
      DateIn: {
        min: undefined,
        max: undefined,
      },
      reload: false,
      validationSummary: [],
      refreshHeaderForm: true,
      serverError: {},
      refreshDataGrid: false,
      displayCurrencyCode: "AUD",
      GLEntryItems: new ArrayStore({
        key: "ID",
        data: [],
      }),
      GLItems: [],
    };
  },

  async created() {},
  async mounted() {
    // await this.$store.dispatch(
    //   "defaultCustomerSettings/setCustomerById",
    //   this.baseView.id
    // );
    this.initialized();
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    backButtonRoute() {
      if (this.baseView.mode == "review") {
        return "/customer-transaction-history/";
      } else {
        return "/customer";
      }
    },
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    getScreenJson() {
      var screenJson = {
        title: "Credit Customer",
        endpoint: {
          primary: this.baseView.mode !== "review" ? undefined : "Invoice",
          CodeBy: this.baseView.mode !== "review" ? "text" : undefined,
          postProcess: this.customerPostProcess,
        },
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "InvoiceDetail",
              filter: ["InvoiceCode eq " + this.baseView.id],
              serverPaging: true,
              allowGrouping: false,
              expand: "SaleItem",
              //   postProcessCallback: this.PostProcess,
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              review: {
                addNew: {
                  class: "no-data",
                  title: "No Credit Lines",
                  message: "Get Started, Add a Credit Line",
                },
              },
            },
            dataGridViews:
              this.baseView.mode !== "review"
                ? [
                    {
                      label: "GL Entry",
                      value: "general-ledger",
                      default: true,
                      dataSource: {
                        localDataList: true,
                        items: this.PostProcess(this.GLEntryItems._array),
                      },
                    },
                    {
                      label: "Review",
                      value: "review",
                      dataSource: {
                        items: [],
                      },
                    },
                  ]
                : undefined,
            options: {
              keyboardNavigation: {
                enabled: this.baseView.mode != "review",
                key: "ID",
              },
              focusedRowEnabled: this.baseView.mode != "review",
              onEditorPreparing: this.onEditorPreparing,
              onFocusedCellChanged: this.onFocusedCellChanged,
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
          },
          columns: [
            this.baseView.mode == "review"
              ? {
                  screenField: "ProductAccount",
                  allowEditing: false,
                  sortOrder: "asc",
                  sortIndex: 0,
                  dataField: "ItemCode",
                  label: "Account",
                  calculateSortValue: "ItemDescription",
                  // filterDataField: "ItemCode",
                  gridDataField: "ItemCode",
                  cellTemplateRecord: {
                    primary: [
                      {
                        dataField: "ItemDescription",
                      },
                    ],
                    secondary: [
                      {
                        dataField: "ItemCode",
                      },
                    ],
                  },
                  exportFields: [
                    {
                      dataField: "ItemCode",
                      label: "Item Code",
                    },
                    {
                      dataField: "ItemDescription",
                      label: "Item Description",
                    },
                  ],
                }
              : {
                  label: "Account",
                  dataField: "ComputedStringCode",
                  // fixed: true,
                  // fixedPosition: "left",
                  minWidth: ColumnWidth.AccountCode.minWidth,
                  cssClass: "edit-cell-textbox-field",
                  allowEditing: this.baseView.mode != "review",
                  editorType: "dxSelectBox",
                  editorOptions: {
                    dataSource: PurchaseOrder.dataSourceConfig("api/GLChart", {
                      filter: [["Inactive", "=", "N"]],
                      sort: [{ selector: "ComputedStringCode", asc: true }],
                    }),
                    displayExpr: "ComputedStringCode",
                    valueExpr: "ComputedStringCode",
                    searchTimeout: 10,
                    searchEnabled: true,
                    searchExpr: ["ComputedStringCode", "Description"],
                    itemTemplate: (data) => {
                      return ` <div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${data.ComputedStringCode}
                        </span>
                        <span class="record-secondary gc-grid-code">
                          ${data.Description}
                        </span>
                      </div>`;
                    },

                    onSelectionChanged: (e) => {
                      this.addSelectedGLItems(e);
                    },
                    onKeyDown: (e, lineData) => {
                      this.onEnterItemCode(e, lineData, "TaxCode");
                    },
                    onItemClick: (e, lineData) => {
                      this.onEnterItemCode(
                        { event: { key: "Enter" } },
                        lineData,
                        "TaxCode"
                      );
                    },
                    dropDownOptions: {
                      width: 400,
                    },
                  },
                  setCellValue: (newData, value, currentRowData) => {
                    newData.ComputedStringCode = value;
                    newData.ItemCode = value.toString();
                    newData.Code = value;
                    newData.TaxCode = "G";

                    var tax = this.taxDataSourceItems.filter(
                      (t) => t.Code == newData.TaxCode
                    );
                    if (tax.length > 0) {
                      newData.SalesTaxPcnt = tax[0].Rate;
                      newData.WetPcnt = tax[0].WetRate;
                    }

                    this.GLCodeChanged(value, currentRowData);

                    if (!currentRowData.ComputedStringCode)
                      this.GLEntryItems.insert(this.getNewRowDataForGLEntry());
                    return newData;
                  },
                },
            {
              label: "Description",
              dataField: "ItemDescription",
              allowEditing: false,
              allowSearch: this.baseView.mode == "review",
              allowSorting: this.baseView.mode == "review",
              minWidth: ColumnWidth.ProductDescription.minWidth,
              visible: this.baseView.mode != "review",
            },
            {
              screenField: "TaxCode",
              gridDataField: "TaxCode",
              label: "Tax",
              width: ColumnWidth.TaxCode.width,
              minWidth: ColumnWidth.TaxCode.minWidth,
              allowSorting: false,
              allowSearch: false,
              // valueExpr: "Code",
              // displayExpr: "Code",
              // readOnly: this.taxCodeReadOnly,
              makeReadOnly: () => {
                return this.taxCodeReadOnly;
              },
              cellTemplate:
                this.dataViewType == "review" ? "Record" : undefined,
              cssClass: "edit-cell-textbox-field",
              allowEditing: this.baseView.mode != "review",
              editorType: "dxSelectBox",
              editorOptions: {
                items: this.taxDataSourceItems,
                valueExpr: "Code",
                displayExpr: "Code",
                itemTemplate: (data) => {
                  return ` <div class="custom-auto-complete" id="${data.Code}" >
                  <span class="auto-complete-primary">
                    ${data.Description}
                  </span>
                  <span class="record-secondary gc-grid-code">
                    ${data.Code}
                  </span>
                </div>`;
                },
                dropDownOptions: {
                  minWidth: 150,
                },
                onKeyDown: (e, lineData) => {
                  this.onEnterItemCode(e, lineData, "SalesUMCreditQty");
                },
                onItemClick: (e, lineData) => {
                  this.onEnterItemCode(
                    { event: { key: "Enter" } },
                    lineData,
                    "SalesUMCreditQty"
                  );

                  lineData.data.TaxCode = e.itemData.Code;
                  lineData.data.WetPcnt = e.itemData.WetRate;
                  lineData.data.SalesTaxPcnt = e.itemData.Rate;

                  if (lineData.data.SalesUMCreditQty == 0) {
                    lineData.data.SalesUMQty = 0;
                    this.getSaleItemPrice(lineData.data);
                  } else {
                    this.calcFormulas(lineData.data);
                    this.GLEntryItems.update(lineData.data.ID, lineData.data);
                  }
                },
              },
              setCellValue: (newData, value) => {
                newData.TaxCode = value;
                return newData;
              },
            },
            {
              screenField: "SalesUM",
              allowEditing: false,
              allowSorting: false,
              width: ColumnWidth.UnitOfMeasure.width,
              minWidth: ColumnWidth.UnitOfMeasure.minWidth,
              allowSearch: false,
            },

            {
              screenField: "SalesUMCreditQty",
              type: "EditableDecimal",
              showEditorAlways: false,
              allowEditing: true,
              gridLabel: "Credit Qty",
              allowSorting: false,
              gridDataField:
                this.baseView.mode !== "review"
                  ? "SalesUMCreditQty"
                  : "SalesUMQty",
              allowSearch: false,
              width: ColumnWidth.Quantity2DecimalPoints.width,
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
            },
            {
              screenField: "SalesUMNetFXPrice",
              type: "EditableDecimal",
              showEditorAlways: false,
              allowEditing: this.baseView.mode != "review",
              // type: "Decimal"
              gridLabel: `Net (Customer Currency)`,
              allowSorting: false,
              allowSearch: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "TaxableFXLineTotal",
              allowEditing: false,
              gridLabel: `Ex Tax (Customer Currency)`,
              // gridLabel: "Quantity"
              allowSorting: false,
              allowSearch: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "GstAmount",
              dataField: "TaxFXLineTotal",
              location: "right",
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
              label: "Tax (" + this.getCurrencyCode + ")",
              // customCalc: (headerData) => {
              //   return headerData.TaxFXLineTotal;
              // },
            },
            {
              screenField: "ProductCategory1",
              filterIndex: 0,
              showInColumnChooser: false,
              allowExporting: true,
              visible: false,
              allowSearch: false,
            },
            {
              screenField: "FXTotal",
              dataField: "FXLineTotal",
              location: "right",
              width: ColumnWidth.Price4DecimalPoints.width,
              minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
              label: "Inc Tax (" + this.getCurrencyCode + ")",
            },

            // {
            //   // visible: this.baseView.mode == "review",
            //   screenField: "GridRecordEllipsisMenu",
            //   allowEditing: false,
            //   allowSearch: false,
            //   showInColumnChooser: false,
            //   allowSorting: false,
            // },

            {
              screenField: "Comments",
              dataField: "Comment",
              allowEditing: this.baseView.mode != "review",
              showEditorAlways: false,
              allowSearch: false,
              allowSorting: false,
              minWidth: ColumnWidth.Comment.minWidth,
              editCellTemplate: "EditableTextArea",
            },
            {
              caption: "",
              dataField: "",
              type: "buttons",
              width: 100,
              buttons: [
                {
                  name: "add",
                  icon: "add",
                  onClick: (e) => {
                    this.addNewRowByPosition(e, "add-line");
                  },
                },
                {
                  name: "copy",
                  icon: "copy",
                  onClick: (e) => {
                    this.addNewRowByPosition(e, "copy-line");
                  },
                },
                {
                  name: "remove",
                  icon: "trash",
                  onClick: (e) => {
                    this.addNewRowByPosition(e, "remove-line");
                  },
                },
              ],
              visible: this.baseView.mode != "review",
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "SalesUMCreditQty",
              listner: (e, lineData, grid) => {
                var value = -Math.abs(e.value);
                e.component.beginUpdate();
                e.component.option("value", value);
                e.component.endUpdate();

                lineData.data.SalesUMCreditQty = value;
                lineData.data.SalesUMQty = value;

                this.getSaleItemPrice(lineData.data);

                var index = this.reviewDataSource.findIndex(
                  (x) => x.ID == lineData.data.ID
                );
                if (e.value == 0) {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                } else {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                  this.addToReview(lineData.data);
                }
                grid.repaintRows([lineData.rowIndex]);
                return;
              },
            },
            {
              dataField: "SalesUMNetFXPrice",
              listner: (e, lineData) => {
                var salesUMNetFXPrice = +Math.abs(e.value);
                e.component.beginUpdate();
                e.component.option("value", salesUMNetFXPrice);
                e.component.endUpdate();

                lineData.data.SalesUMNetFXPrice = salesUMNetFXPrice;
                if (lineData.data.SalesUMCreditQty == 0) {
                  lineData.data.SalesUMCreditQty = 0;
                  lineData.data.SalesUMQty = 0;
                  this.getSaleItemPrice(lineData.data);
                } else {
                  this.calcFormulas(lineData.data);
                }
              },
            },
            {
              dataField: "TaxCode",
              listner: (e, lineData) => {
                lineData.data.TaxCode = e.itemData.Code;
                lineData.data.WetPcnt = e.itemData.WetRate;
                lineData.data.SalesTaxPcnt = e.itemData.Rate;

                if (lineData.data.SalesUMCreditQty == 0) {
                  lineData.data.SalesUMQty = 0;
                  this.getSaleItemPrice(lineData.data);
                } else {
                  this.calcFormulas(lineData.data);
                }
              },
            },

            {
              dataField: "Comment",
              listner: (e, lineData) => {
                if (e.value.length >= 1000) {
                  this.addToValidationSum(
                    "comments only allow maximum length of 1000 characters"
                  );
                  lineData.data.Comment = e.previousValue;
                  e.component.beginUpdate();
                  e.component.option("value", e.previousValue);
                  e.component.endUpdate();
                } else lineData.data.Comment = e.value;
                var index = this.reviewDataSource.findIndex(
                  (x) => x.ID == lineData.data.ID
                );
                if (e.value) {
                  if (index != -1) {
                    this.removeFromReview(index);
                  }
                  if (
                    lineData.data.SalesUMCreditQty > 0 ||
                    lineData.data.Comment
                  )
                    this.addToReview(lineData.data);
                } else {
                  if (index != -1 && lineData.data.SalesUMCreditQty == 0) {
                    this.removeFromReview(index);
                  }
                }
                // this.footerValueCalculations(lineData);
              },
            },
          ],
          ellipsisColumn: {
            items: [
              {
                label: "Line Comment",
                clickAction: "lineComment",
              },
            ],
            keyExpr: "label",
            displayExpr: "label",
            formItems: [
              {
                itemType: "group",
                caption: "",
                colCount: 1,
                items: [
                  {
                    dataField: "Comment",
                    label: { text: "Comment", visible: false },
                    editorType: "dxTextArea",
                    editorOptions: {
                      height: "140",
                      maxLength: 1000,
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
          },
        },
        footerData: {
          footerItems: [
            {
              screenField: "SalesUMItemCount",
              dataField:
                this.baseView.mode !== "review"
                  ? "SalesUMCreditQty"
                  : "SalesUMQty",
              location: "left",
              // label: "Item Count",
              value: 0,
              // format: "Decimal-16-0",
            },
            {
              dataField: "TaxableFXLineTotal",
              screenField: "TaxableFXTotal",
              // dataField: "TaxableFXTotal",
              location: "right",
              // label: `Sub Total (${
              //   getDefaultCustomerSettings().CustomerCurrency
              // })`,
              value: 0,
              label: "Sub Total (Customer Currency)",
              // format: "Decimal-16-2C",
            },
            {
              screenField: "TaxFXTotal",
              dataField: "TaxFXLineTotal",
              // dataField: "TaxFXTotal",
              location: "right",
              // label: `Tax (${getDefaultCustomerSettings().CustomerCurrency})`,
              value: 0,
              customCalc:
                this.baseView.mode == "create"
                  ? (headerData, gridItems) => {
                      var total = 0;
                      gridItems.forEach((element) => {
                        total =
                          total.roundNumber(2) +
                          element.TaxFXLineTotal.roundNumber(2);
                      });
                      return total;
                    }
                  : (headerData) => {
                      return headerData.TaxFXTotal;
                    },
              // format: "Decimal-16-2C",
            },
            {
              screenField: "FXTotal",
              dataField:
                this.baseView.mode == "create"
                  ? "IncTaxFXTotal"
                  : "IncTaxFXTotal",
              location: "right",
              value: 0,
              label: "Total (" + this.getCurrencyCode + ")",
              customCalc:
                this.baseView.mode == "create"
                  ? (headerData, gridItems) => {
                      var total = 0;
                      gridItems.forEach((element) => {
                        total =
                          total.roundNumber(2) +
                          element.FXLineTotal.roundNumber(2);
                      });

                      return total;
                    }
                  : (headerData) => {
                      return headerData.IncTaxFXTotal;
                    },
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          headerFormVisible: true,
          headerFormSplitView: true,
          headerToolbar: {
            screenName: "Credit Customer Review",
            pdf: this.baseView.mode == "review",
            email: this.baseView.mode == "review",
            audit: this.baseView.mode != "create",
            status: this.baseView.mode != "create",
            notes: false,
            save: this.baseView.mode !== "review",
            saveCallback: this.saveData,
            commentsTitle: "Credit Comments",
            commentsAsForm: true,

            toolbarFormItems: [
              {
                screenField: "Customer",
                dataField: "CustomerCode",
                cssClass: "toolbar-customer-label",
                visible: this.baseView.mode != "review",
                editorOptions: {
                  dropDownOptions: {
                    minWidth: 300,
                  },
                  width: 300,
                  placeholder: "Customer Name",
                  // onValueChanged: this.onCustomerCodeValueChanged.bind(this),
                  showClearButton: true,
                  onItemClick: (e) => {
                    this.onCustomerCodeItemClicked(e);
                  },
                  /* eslint-disable no-unused-vars */
                  onValueChanged: ({ value, previousValue }) => {
                    if (previousValue) {
                      this.$store.dispatch(
                        "dataContext/setReviewDataSource",
                        []
                      );

                      this.GLEntryItems.clear();
                      this.GLEntryItems.insert(this.getNewRowDataForGLEntry());
                    }

                    var dataGridInstance =
                      this.$refs["customer-credit"].$refs["transactionGrid"]
                        .$refs["gc-dat-gridtransaction-grid"].instance;

                    dataGridInstance.option("focusedRowKey", null);
                  },
                },
                label: {
                  text: "Customer",
                  visible: false,
                },
                required: true,
              },
            ],

            customButtons: [
              {
                label: "save",
                icon: "..",
                type: " ",
                click: "",
                menu: [
                  {
                    label: "Credit Comments",
                    clickAction: "",
                  },
                ],
              },
            ],

            emailMenuItems: {
              referenceNoField: "Code",
              makeDisabled: (dataModel, emailRecords) => {
                var items = [];
                emailRecords.forEach((element) => {
                  items.push({
                    ReportDisplayName: element.ReportDisplayName,
                    ScreenName: element.ScreenName,
                    ScreenLayoutApplicationFeatureCode:
                      element.ScreenLayoutApplicationFeatureCode,
                    TransactionCode: element.TransactionCode,
                    disabled: element.disabled,
                  });
                });
                return items;
              },
            },
            formContentReady: this.toolBarFormContentReady,
            auditItems: [
              {
                itemType: "group",
                caption: "",
                items: [
                  {
                    dataField: "FormattedDateCreated",
                    label: { text: "Created By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // // disabled: true,
                    },
                  },
                  {
                    dataField: "FormattedDateChanged",
                    label: { text: "Changed By", location: "left" },
                    editorType: "dxTextBox",
                    editorOptions: {
                      // disabled: true,
                    },
                  },
                ],
              },
            ],
            orderComments: {
              dataField: "SalesOrderTypeCode",
              endpoint: "SalesOrderType",
              toMatch: [
                "UserComment1",
                "UserComment2",
                "UserComment3",
                "UserComment4",
                "UserComment5",
                "UserComment6",
                "UserComment7",
                "UserComment8",
                "UserComment9",
                "UserComment10",
                "UserComment11",
                "UserComment12",
                "UserComment13",
                "UserComment14",
                "UserComment15",
                "UserComment16",
                "UserComment17",
                "UserComment18",
                "UserComment19",
                "UserComment20",
              ],
            },
            commentItems: [
              {
                itemType: "group",
                caption: "",
                items: [],
              },
            ],
          },
          deliveryAddressItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 1,
              items: [
                {
                  dataField: "DeliveryAddressCompanyName",
                  editorType: "dxTextBox",
                  label: {
                    text: "Name",
                  },
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine1",
                  dataField: "DeliveryAddressStreetLine1",
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressStreetLine2",
                  dataField: "DeliveryAddressStreetLine2",
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressSuburb",
                  dataField: "DeliveryAddressSuburb",
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressState",
                  dataField: "DeliveryAddressState",
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressPostcode",
                  dataField: "DeliveryAddressPostcode",
                  // allowUpdate: false,
                },
                {
                  screenField: "PhysicalAddressCountry",
                  dataField: "DeliveryAddressCountry",
                  // allowUpdate: false,
                },
              ],
            },
          ],
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 2,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      editorOptions: {
                        displayFormat: "dd MMM yyyy",
                        value:
                          this.baseView.mode != "review"
                            ? new Date()
                            : undefined,
                        min: this.DateIn.min,
                        max: this.DateIn.max,
                      },
                      required: this.baseView.mode != "review",
                    },
                    {
                      dataField: "OrderNo",
                      screenField: "CustPO",
                    },
                    // {
                    //   dataField: "ConsignmentNo",
                    //   screenField: "ConNote",
                    // },

                    {
                      itemType: "group",
                      caption: "",
                      cssClass: "deliver-to",
                      items: [
                        {
                          screenField: "DeliverTo",
                          dataField: "DeliveryAddressCompanyName",
                          label: {
                            text: "Deliver To",
                          },
                          allowUpdate: true,
                          editorOptions: {
                            tabIndex: -1,
                          },
                          required: this.baseView.mode != "review",
                          onItemClick: this.setDeliveryAddress,
                          acceptCustomValue: true,
                          onCustomItemCreating: (data) => {
                            if (!data.text) {
                              data.customItem = null;
                              return;
                            }

                            const newItem = {
                              CompanyName: data.text,
                              PhysicalAddressCountry: "",
                              PhysicalAddressPostcode: "",
                              PhysicalAddressState: "",
                              PhysicalAddressStreetLine1: "",
                              PhysicalAddressStreetLine2: "",
                              PhysicalAddressSuburb: "",
                            };

                            data.customItem = newItem;
                          },
                          ref: "DeliveryAddressCompanyName",
                          dataSourceConfig: {
                            data: deliveryAddressDataSourceItems,
                          },
                        },
                        {
                          screenField: "DeliveryCompanyView",
                          editAddress:
                            this.baseView.mode != "review" ? true : false,
                        },
                      ],
                    },
                    {
                      itemType: "group",
                      caption: "",
                      colCount: 2,
                      items: [
                        {
                          screenField: "ExchangeRate",
                          dataField: "ExchangeRate",
                          cssClass: "exchange-rate",
                          editorOptions: {
                            tabIndex: -1,
                            readOnly: true,
                          },
                        },
                        {
                          dataField: "CurrencyCode",
                          label: {
                            text: "Currency",
                            visible: false,
                          },
                          editorOptions: {
                            tabIndex: -1,
                            readOnly: true,
                          },
                        },
                      ],
                    },
                  ],
                },

                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      dataField: "BranchCode",
                      screenField: "Branch",
                      // allowUpdate: false,
                      defaultValue: this.getDefaultBranch,
                      required: true,
                    },
                    {
                      dataField: "DivisionCode",
                      screenField: "Division",
                      defaultValue: this.getDefaultDivision,
                      required: true,
                      // allowUpdate: false,
                    },
                    {
                      // dataField: "SalesOrderTypeDescription",
                      screenField: "OrderType",
                      // allowUpdate: false,
                      defaultValue: this.getDefaultOrderType,
                      required: true,
                      onValueChange: (e) => {
                        this.changeCreditCommentsForm(e.value);
                      },
                    },
                    {
                      screenField: "OrderRep",
                      // allowUpdate: false,
                      required: true,
                      defaultValue: this.getDefaultSalesRep,
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: this.baseView.mode !== "review" ? undefined : "Code",
                text:
                  this.baseView.mode !== "review"
                    ? "Create Customer Credit"
                    : "Credit # ",
              },
              secondary: {
                dataField: undefined,
                text: undefined,
              },
            },
            secondary: {
              dataField:
                this.baseView.mode !== "review" ? undefined : "CustomerName",
              text: undefined,
            },
          },
        },
      };
    },
    getDefaultBranch() {
      if (this.dataModel)
        return this.dataModel["BranchCode"]
          ? this.dataModel["BranchCode"]
          : this.defaultBranchCode;
      else return this.defaultBranchCode;
    },
    getDefaultDivision() {
      return this.defaultDivisionCode;
    },
    getDefaultOrderType() {
      return this.defaultOrderTypeCode;
    },
    getDefaultSalesRep() {
      return this.defaultSalesRepCode;
    },
    taxCodeReadOnly() {
      return (
        getDefaultCustomerSettings().CustomerCurrency !=
          getDefaultUserSettings().CurrencyCode ||
        this.baseView.mode == "review"
      );
    },
    getCurrencyCode() {
      if (this.dataModel.CurrencyCode) return this.dataModel.CurrencyCode;
      else return this.displayCurrencyCode;
    },
  },
  methods: {
    onFocusedCellChanged(e) {
      if (e.column.allowEditing) {
        this.focusOnEditableCell(e.rowIndex, e.column.dataField);
      }
    },
    toolBarFormContentReady(e) {
      if (
        e &&
        this.baseView.mode != "review" &&
        this.loaded
        // &&
        // this.IsCustomerEditable == true
      )
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("CustomerCode"))
            headerToolBarForm.getEditor("CustomerCode").instance().focus();
        }, 500);

      this.headerFormToolbarIntance = e.component;
    },
    async addNewRowByPosition(e, type) {
      this.validationSummary = [];
      if (!e.row.data.ItemCode && type == "copy-line") {
        this.validationSummary.push({
          message: "Account is required",
        });
      } else {
        if (type == "remove-line") {
          let confirmDelete = await this.$confirm(
            "Are you sure you want to delete this record ?",
            "Delete Record"
          );
          if (confirmDelete) {
            this.GLEntryItems._array.splice(e.row.rowIndex, 1);
          }
        } else {
          let dataObj = undefined;

          if (type == "add-line") {
            dataObj = this.getNewRowDataForGLEntry();
          } else {
            dataObj = Object.assign({ ...e.row.data });
            dataObj.LineNo = 0;
          }

          dataObj.ID = new Date().getTime();
          this.GLEntryItems._array.splice(e.row.rowIndex + 1, 0, dataObj);
        }

        setTimeout(() => {
          this.$refs["customer-credit"].$refs["transactionGrid"].$refs[
            "gc-dat-gridtransaction-grid"
          ].instance.refresh();
          this.onEnterItemCode(
            { event: { key: "Enter" } },
            {
              rowIndex: e.row.rowIndex,
            },
            "next"
          );

          if (this.GLEntryItems._array.length == 0) {
            this.GLEntryItems.insert(this.getNewRowDataForGLEntry()).then(
              () => {
                this.onEnterItemCode(
                  { event: { key: "Enter" } },
                  {
                    rowIndex: 0,
                  },
                  "ComputedStringCode"
                );
              }
            );
          }
        }, 250);
      }
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onFocusIn) {
        let func = e.editorOptions.onFocusIn;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel") {
          e.editorOptions.onFocusIn = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }
      }
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (this.baseView.mode != "review" && e.parentType != "searchPanel")
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }
    },
    GLCodeChanged(value, currentRowData) {
      var item = this.GLItems.find((x) => x.Code == value);

      if (item)
        this.GLEntryItems.update(currentRowData.ID, {
          ItemDescription: item.Description,
        });
    },
    addSelectedGLItems(e) {
      if (e.selectedItem) {
        var index = this.GLItems.findIndex(
          (x) => x.Code == e.selectedItem.Code
        );
        if (index == -1) this.GLItems.push(e.selectedItem);
      }
    },
    onEnterItemCode(e, lineData, nextField) {
      if (e.event.key == "Enter") {
        if (!this.validateCustomerCode()) {
          return;
        }

        setTimeout(() => {
          this.focusOnEditableCell(lineData.rowIndex, nextField);
        }, 100);
      }
    },
    focusOnEditableCell(rowIndex, col) {
      var columnName = col ? col : "ItemCode";
      var dataGrid =
        this.$refs["customer-credit"].$refs["transactionGrid"].$refs[
          "gc-dat-gridtransaction-grid"
        ].instance;

      if (col == "next") {
        if (dataGrid.getKeyByRowIndex(rowIndex + 1)) {
          rowIndex = rowIndex + 1;
          columnName = "ComputedStringCode";
        }
      }

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },
    getNewRowDataForGLEntry() {
      var tax = this.taxDataSourceItems.filter(
        (t) => t.Code == this.defaultTaxCode
      );
      if (tax.length > 0) {
        this.taxData.SalesTaxPcnt = tax[0].Rate;
        this.taxData.WetRate = tax[0].WetRate;
      }

      var rowData = {
        ...glItemBase,
        ID: new Date().getTime(),
        TaxCode: this.defaultTaxCode,
        SalesUM: "EA",
        SalesTaxPcnt: this.taxData.SalesTaxPcnt,
        WetPcnt: this.taxData.WetRate,
        IsBatchProduct: "No",
      };

      return rowData;
    },
    async setDeliveryAddressDataSourceItems(customerCode, lineNo) {
      let deliveryAddresDs = CustomerDeliveryAddressService.dataSourceConfig(
        "api/CustomerDeliveryAddress",
        {
          select: [
            "CompanyName",
            "PhysicalAddressStreetLine1",
            "PhysicalAddressStreetLine2",
            "PhysicalAddressSuburb",
            "PhysicalAddressState",
            "PhysicalAddressPostcode",
            "PhysicalAddressCountry",
            "RecordId",
            "LineNo",
          ],
          key: "RecordId",
          filter: [
            ["Inactive", "=", "N"],
            "and",
            ["CustomerCode", "=", customerCode],
          ],
        }
      );

      let results = await deliveryAddresDs.load();

      let defaultLineNo = 1;
      if (lineNo) defaultLineNo = lineNo;

      let deliveryAddressLine1Record = results.find(
        (x) => x.LineNo == defaultLineNo
      );

      if (deliveryAddressLine1Record) {
        deliveryAddressDataSourceItems = results;
        if (this.DeliveryAddressCompanyNameEditor()) {
          this.DeliveryAddressCompanyNameEditor().beginUpdate();
          this.DeliveryAddressCompanyNameEditor().option(
            "items",
            deliveryAddressDataSourceItems
          );
          this.DeliveryAddressCompanyNameEditor().option(
            "value",
            deliveryAddressLine1Record.CompanyName
          );
          this.DeliveryAddressCompanyNameEditor().endUpdate();
        }

        if (lineNo) {
          this.dataModel.DeliveryAddressCompanyName =
            deliveryAddressLine1Record.CompanyName;

          this.dataModel.DeliveryAddressCountry =
            deliveryAddressLine1Record.PhysicalAddressCountry;
          this.dataModel.DeliveryAddressPostcode =
            deliveryAddressLine1Record.PhysicalAddressPostcode;
          this.dataModel.DeliveryAddressState =
            deliveryAddressLine1Record.PhysicalAddressState;
          this.dataModel.DeliveryAddressStreetLine1 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine1;
          this.dataModel.DeliveryAddressStreetLine2 =
            deliveryAddressLine1Record.PhysicalAddressStreetLine2;
          this.dataModel.DeliveryAddressSuburb =
            deliveryAddressLine1Record.PhysicalAddressSuburb;
          this.dataModel.CustomerDeliveryAddressLineNo =
            deliveryAddressLine1Record.LineNo;
        }
      }
    },
    HeaderFormInstance() {
      if (this.loaded && this.$refs) {
        return this.$refs["customer-credit"].$refs["gc-header-form-component"]
          .$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      } else {
        return undefined;
      }
    },
    DeliveryAddressCompanyNameEditor() {
      if (this.loaded) {
        var headerFormInstance =
          this.$refs["customer-credit"].$refs["gc-header-form-component"].$refs[
            "gc-header-form"
          ].$refs["gc-form-comp"].instance;
        return headerFormInstance.getEditor("DeliveryAddressCompanyName");
      } else return undefined;
    },

    // onCustomerCodeValueChanged(e) {
    //   console.log("onCustomerCodeValueChanged ", e);
    // },
    async onCustomerCodeItemClicked(e) {
      this.dataModel = await this.customerPostProcess(e.itemData);
      this.dataModel.CustomerCode = e.itemData.Code;
      this.dataModel.CurrencyCode = e.itemData.CurrencyCode;
      this.dataModel.Currency = e.itemData.CurrencyCode;

      if (this.dataModel.CurrencyCode)
        this.$store.dispatch(
          "defaultCustomerSettings/setCustomerCurrencyCode",
          this.dataModel.CurrencyCode
        );
      else
        this.$store.dispatch(
          "defaultCustomerSettings/setCustomerById",
          this.dataModel.CustomerCode
        );

      var data = e.itemData;
      if (data.CurrencyCode) {
        ForeignCurrencyService.getByCode(data.CurrencyCode).then((res) => {
          this.dataModel["ExchangeRate"] = res.data.value[0].BuyRate;
        });
      } else {
        this.dataModel["ExchangeRate"] = 1;
      }

      this.setDeliveryAddressDataSourceItems(data.Code, 1);

      this.setDefaultSalesRep(this.dataModel.CustomerCode);

      this.$refs["customer-credit"].$refs["transactionGrid"].gridRepaint();
    },
    addToValidationSum(message) {
      this.validationSummary = [];
      this.validationSummary.push({
        message: message,
      });
    },
    calcFormulas(record) {
      var exchangeRate =
        this.$refs["customer-credit"].getTransactionData().ExchangeRate;

      record.SalesUMPrice = calculateSalesUMPriceFromSalesUMFXPrice(
        record.SalesUMNetFXPrice,
        exchangeRate
      );

      record.SalesUMFXPrice = calculateSalesUMFXPrice(
        record.SalesUMPrice,
        exchangeRate
      );

      record.SalesUMNetFXPrice = calculateSalesUMNetFXPrice(
        record.SalesUMFXPrice,
        record.DiscPcnt
      );

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        exchangeRate
      );

      record.DiscFXLineTotal = calculateDiscFXLineTotal(
        record.SalesUMFXPrice,
        record.SalesUMNetFXPrice,
        record.SalesUMQty
      );

      // FX Totals
      record.NetFXLineTotal = calculateNetFXLineTotal(
        record.SalesUMNetFXPrice,
        record.SalesUMQty,
        record.SalesUMFXPrice
      );

      record.WetFXLineTotal = calculateWetFXLineTotal(
        record.NetFXLineTotal,
        record.WetPcnt
      );

      record.TaxableFXLineTotal = calculateTaxableFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal
      );

      record.TaxFXLineTotal = calculateTaxFXLineTotal(
        record.NetFXLineTotal,
        record.WetFXLineTotal,
        record.SalesTaxPcnt
      );

      record.FXLineTotal = calculateFXLineTotal(
        record.TaxableFXLineTotal,
        record.TaxFXLineTotal
      );

      // Totals
      record.DiscLineTotal = calculateDiscLineTotal(
        record.DiscFXLineTotal,
        exchangeRate
      );

      record.NetLineTotal = calculateNetLineTotal(
        record.NetFXLineTotal,
        exchangeRate
      );

      record.WetLineTotal = calculateWetLineTotal(
        record.WetFXLineTotal,
        exchangeRate
      );

      record.TaxableLineTotal = calculateTaxableLineTotal(
        record.TaxableFXLineTotal,
        exchangeRate
      );

      record.TaxLineTotal = calculateTaxLineTotal(
        record.TaxFXLineTotal,
        exchangeRate
      );

      record.LineTotal = calculateLineTotal(record.FXLineTotal, exchangeRate);

      record.SalesUMNetPrice = calculateSalesUMNetPriceFromSalesUMNetFXPrice(
        record.SalesUMNetFXPrice,
        exchangeRate
      );

      record.StockUMQty = calculateStockUMQty(
        record.SalesUMQty,
        record.SalesUMConversion
      );

      // Stock
      record.StockUMFXPrice = calculateStockUMFXPrice(
        record.SalesUMFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetFXPrice = calculateStockUMNetFXPrice(
        record.SalesUMNetFXPrice,
        record.SalesUMConversion
      );

      record.StockUMNetPrice = calculateStockUMNetPrice(
        record.SalesUMNetPrice,
        record.SalesUMConversion
      );

      record.StockUMPrice = calculateStockUMPrice(
        record.SalesUMPrice,
        record.SalesUMConversion
      );

      if (record.ItemType.toUpperCase() == "S") {
        record.SalesUMStandardPrice = record.SalesUMPrice;

        record.StockUMStandardPrice = calculateStockUMStandardPrice(
          record.SalesUMPrice,
          record.SalesUMConversion
        );
      } else {
        record.SalesUMStandardPrice = 0;
        record.StockUMStandardPrice = 0;
      }
    },
    async changeCreditCommentsForm(Code) {
      this.setLoading = true;
      await this.setOrderComments(Code);

      this.setLoading = false;
    },
    async setTaxDataSourceItems() {
      let taxDS = TaxCategoryService.dataSourceConfig("api/Tax", {
        sort: {
          selector: "Description",
          asc: true,
        },
        filter: [["Inactive", "=", "N"]],
        select: ["Code,Description,Rate,WetRate"],
      });

      this.taxDataSourceItems = await taxDS.load();
    },
    async initialized() {
      this.setLoading = true;
      await this.$store.dispatch(
        "screenFactors/getFactors",
        [87, 473, 95, 65, 66]
      );
      this.$store.dispatch("dataContext/setReviewDataSource", []);
      this.defaultOrderTypeCode = getFactorByCode(87).Factorc;

      this.setDateInValidation();
      this.defaultBranch();
      this.defaultDivision();
      await this.setTaxDataSourceItems();

      // await this.$store.dispatch(
      //   "defaultCustomerSettings/setCustomerById",
      //   this.baseView.id
      // );
      await this.$store.dispatch(
        "defaultUserSettings/setDefaultCompanyBranchDivision"
      );

      if (this.baseView.mode == "create") {
        // this.dataModel.CustomerCode = this.baseView.id;
        if (this.baseView.id)
          await CustomerService.getByCode(this.baseView.id).then(
            async (res) => {
              res.data.value[0].CustomerCode = res.data.value[0].Code;
              this.dataModel = await this.customerPostProcess(
                res.data.value[0]
              );

              // this.dataModel.CustomerCode = this.dataModel.Code;
              // this.dataModel = res.data.value[0];

              this.$store.dispatch(
                "defaultCustomerSettings/setCustomerCurrencyCode",
                this.dataModel.CurrencyCode
              );
            }
          );

        this.GLEntryItems.insert(this.getNewRowDataForGLEntry());
        setTimeout(async () => {
          await this.setOrderComments(this.defaultOrderTypeCode);
        }, 500);
      }

      this.setDefaultSalesRep(this.baseView.id);

      // this.refreshHeaderForm = false;
      this.loaded = true;
    },
    // eslint-disable-next-line no-unused-vars
    async saveData(headerData, getDetailLines) {
      this.setLoading = false;
      await this.$nextTick();
      this.validationSummary = [];
      if (this.reviewDataSource.length == 0) {
        // this.$notify(
        //   `Credit has no detail.  Please credit one or more lines before attempting to save the transaction again.`,
        //   "error"
        // );
        this.validationSummary.push({
          message: `Credit has no detail.  Please credit one or more lines before attempting to save the transaction again.`,
        });
        return;
      }

      this.setLoading = true;
      var payload = this.setPayload(headerData);

      var InvoiceDetails = [];

      var TaxTotal = 0;
      var Total = 0;

      this.reviewDataSource.forEach((element) => {
        InvoiceDetails.push(this.setDetailsPayload(element));
        TaxTotal = TaxTotal + element.TaxLineTotal;
        Total = Total + element.LineTotal;
      });

      payload.InvoiceDetails = InvoiceDetails;
      payload.TransactionFlag = 11;
      payload.OriginalInvoiceCode = 0;
      payload.TaxTotal = TaxTotal;
      payload.Total = Total;

      await TransactionService.saveTransaction(payload)
        .then((res) => {
          this.$notify(
            `Credit # ${res.data.Code} saved successfullly`,
            "success"
          );
          this.setIgnoreRouteChangeConfirmation();
          this.loaded = false;
          this.reload = true;
          this.$router
            .push({
              path: `/credit-customer/review/${res.data.Code}`,
            })
            .then((res) => {
              this.reload = false;
              if (res) {
                this.baseView.mode = "review";
                this.initialized();
              }
            });
        })
        .catch((error) => {
          // this.displayServerError(error, "Credit Invoice save failed");
          this.setLoading = false;

          this.serverError = {
            err: error,
            msg: "Credit Invoice save failed",
            time: new Date().getTime(),
          };
        });
    },
    validateCustomerCode() {
      var headerData = this.$refs["customer-credit"].getTransactionData();
      if (!headerData.CustomerCode && !headerData.Code) {
        alert(`Please select a Customer alert.`);

        // this.displayValidationErrors([`Please select a Customer.`]);
        setTimeout(() => {
          this.headerFormToolbarIntance
            .getEditor("CustomerCode")
            .instance()
            .focus();
        }, 200);

        return false;
      }

      return true;
    },
    async getSaleItemPrice(record) {
      var headerData = this.$refs["customer-credit"].getTransactionData();

      var tranDate = new Date(headerData.DateIn).toShortDateString();

      if (!this.validateCustomerCode()) {
        return;
      }

      var requestData = {
        TransactionDate: tranDate,
        SalesOrderTypeCode: headerData.SalesOrderTypeCode,
        BranchCode: headerData.BranchCode,
        CustomerCode: headerData.CustomerCode
          ? headerData.CustomerCode
          : headerData.Code,
        ExchangeRate: headerData.ExchangeRate,
        ItemType: "G", // GLChart
        ItemCode: record.Code,
        SalesUM: record.SalesUM,
        SalesUMQty: record.SalesUMCreditQty,
      };

      await CustomerCreditService.getSaleItemPrice(requestData)
        .then((res) => {
          let data = res.data;

          record.AddDiscPriceGroupCode = data.AddDiscPriceGroupCode;
          record.AddDiscPricingMethod = data.AddDiscPricingMethod;
          record.AddDiscPricingMethodValue =
            data.AddDiscPricingMethodValue || 0;
          record.AddDiscSalesUMPrice = data.AddDiscSalesUMPrice || 0;
          record.AddDiscStockUMPrice = data.AddDiscStockUMPrice || 0;
          record.CalculatedDiscPcnt = data.CalculatedDiscPcnt;
          record.DiscPcnt = data.DiscPcnt;
          record.IsPrimeCostItem = data.IsPrimeCostItem;
          record.PriceGroupCode = data.PriceGroupCode || 0;
          record.PriceGroupSalesUMPrice = data.PriceGroupSalesUMPrice || 0;
          record.PriceGroupStockUMPrice = data.PriceGroupStockUMPrice || 0;
          record.PricingMethod = data.PricingMethod || "";
          record.PricingMethodValue = data.PricingMethodValue || 0;
          // record.SalesTaxPcnt = data.SalesTaxPcnt;
          record.SalesUMConversion = data.SalesUMConversion;
          record.SalesUMCost = data.SalesUMStandardCost;
          record.StockUMStandardCost = data.StockUMStandardCost;
          record.ExTaxUnitCost = data.StockUMStandardCost;
          record.SalesUMFXPrice = data.SalesUMFXPrice;
          record.SalesUMIsVariable = data.SalesUMIsVariable;
          record.SalesUMManufacturedCost = (
            data.StockUMStandardCost * data.SalesUMConversion
          ).roundNumber(4);
          // record.SalesUMQty !== 0 ? (record.SalesUMNetFXPrice = data.SalesUMNetFXPrice) : (record.SalesUMNetFXPrice = 0);
          record.SalesUMNetPrice = data.SalesUMNetPrice;
          record.SalesUMPrice = data.SalesUMPrice;
          record.SalesUMPromotionNetPrice = data.SalesUMPromotionNetPrice;
          record.SalesUMStandardCost = data.SalesUMStandardCost;
          record.SalesUMStandardPrice = data.SalesUMStandardPrice;
          record.StockUM = data.StockUM;
          record.StockUM = data.StockUM;
          record.StockUMFXPrice = data.StockUMFXPrice;
          record.StockUMManufacturedCost = data.StockUMStandardCost;
          record.StockUMNetFXPrice = data.StockUMNetFXPrice;
          record.StockUMNetPrice = data.StockUMNetPrice;
          record.StockUMPrice = data.StockUMPrice;

          record.StockUMStandardPrice = data.StockUMStandardPrice;

          // if (data.TaxCode == record.TaxCode) {
          //   record.WetPcnt = data.WetPcnt;
          //   record.TaxRate = data.SalesTaxPcnt;
          // }
          // record.TaxCode = data.TaxCode;

          this.calcFormulas(record);

          this.GLEntryItems.update(record.ID, record);
        })
        .catch((err) => {
          this.$logger.debug("getSaleItemPrice err", err);
        });
    },

    setDeliveryAddress(item, e) {
      item.DeliveryAddressCompanyName = e.itemData.CompanyName;
      item.DeliveryAddressStreetLine1 = e.itemData.PhysicalAddressStreetLine1;
      item.DeliveryAddressStreetLine2 = e.itemData.PhysicalAddressStreetLine2;
      item.DeliveryAddressSuburb = e.itemData.PhysicalAddressSuburb;
      item.DeliveryAddressState = e.itemData.PhysicalAddressState;
      item.DeliveryAddressPostcode = e.itemData.PhysicalAddressPostcode;
      item.DeliveryAddressCountry = e.itemData.PhysicalAddressCountry;
      item.CustomerDeliveryAddressLineNo = e.itemData.LineNo.toString();
    },
    async customerPostProcess(data) {
      if (data.Gst == "yes") {
        this.defaultTaxCode = getFactorByCode(473).Factorc;
      } else {
        this.defaultTaxCode = "E";
      }

      var taxIndex = this.taxDataSourceItems.findIndex(
        (t) => t.Code == this.defaultTaxCode
      );
      if (taxIndex == -1)
        await TaxCategoryService.getByCode(this.defaultTaxCode).then((res) => {
          this.taxData.SalesTaxPcnt = res.data.value[0].Rate;
          this.taxData.WetRate = res.data.value[0].WetRate;
        });
      else {
        this.taxData.SalesTaxPcnt = this.taxDataSourceItems[taxIndex].Rate;
        this.taxData.WetRate = this.taxDataSourceItems[taxIndex].WetRate;
      }

      if (data.CurrencyCode) {
        await ForeignCurrencyService.getByCode(data.CurrencyCode).then(
          (res) => {
            data.ExchangeRate = res.data.value[0].BuyRate;
          }
        );

        var code = data.CustomerCode ? data.CustomerCode : data.Code;
        var lineNo = data.CustomerDeliveryAddressLineNo
          ? data.CustomerDeliveryAddressLineNo
          : 1;

        setTimeout(() => {
          this.setDeliveryAddressDataSourceItems(code, lineNo);
        }, 400);
      } else {
        data.ExchangeRate = 1;
      }

      data.SalesOrderTypeCode = this.defaultOrderTypeCode;

      data.BranchCode = this.defaultBranchCode;
      if (this.baseView.mode == "create") {
        data.ConsignmentNo = "";
        data.OrderNo = "";
      }

      // - #31321: UI : Customer Credit screen - PDF preview icon and generate PDF of the transaction report
      // - To match ScreenNameToLayout parameter.dataField
      data.Invoice = data.Code;

      return data;
    },
    async setDefaultSalesRep(customerCode) {
      var featureItems = FeatureStorage.getItems();
      if (featureItems[0].ApplicationUserTypeCode == "Sales") {
        await SalesRepresentativeService.getUserDefaultSalesRepresentative().then(
          (res) => {
            this.defaultSalesRepCode =
              res.data.value[0].SalesRepresentativeCode;
          }
        );
      } else {
        if (this.dataModel.SalesRepresentativeCode)
          this.defaultSalesRepCode = this.dataModel.SalesRepresentativeCode;
        else if (customerCode)
          await CustomerService.getByCode(customerCode)
            .then((res) => {
              this.defaultSalesRepCode =
                res.data.value[0].SalesRepresentativeCode;
            })
            .catch((err) => {
              if (err) {
                this.defaultSalesRepCode = getFactorByCode(95).Factorc;
              }
            });
      }
    },
    async defaultDivision() {
      if (getFactorByCode(66).Factorc)
        this.defaultDivisionCode = getFactorByCode(66).Factorc;
      else
        await DivisionService.getDefault().then((res) => {
          this.defaultDivisionCode = res.data.value[0].Code;
        });
    },
    async defaultBranch() {
      if (getFactorByCode(65).Factorc)
        this.defaultBranchCode = getFactorByCode(65).Factorc;
      else {
        await BranchService.getDefault().then((res) => {
          this.defaultBranchCode = res.data.value[0].Code;
        });
      }
    },
    removeFromReview(index) {
      this.reviewDataSource.splice(index, 1);
    },
    addToReview(item) {
      this.reviewDataSource.push(item);
      this.$store.dispatch(
        "dataContext/setReviewDataSource",
        this.reviewDataSource
      );
    },
    PostProcess(data) {
      var items = [];
      data.forEach((element) => {
        element["CheckInclude"] = true;

        element["IsCommentVisible"] = true;
        element["SalesUMInvoiceConversion"] = 1;
        element["OriginalInvoiceLineNo"] = 0;

        items.push(element);
      });

      return items;
    },
    setPayload(data) {
      let {
        TransactionFlag,
        OriginalInvoiceCode,
        BranchCode,
        ConsignmentNo,
        CurrencyCode,
        CustomerCode,
        CustomerDeliveryAddressLineNo,
        DateDue,
        DateIn,
        DeliveryAddressCompanyName,
        DeliveryAddressCountry,
        DeliveryAddressPostcode,
        DeliveryAddressState,
        DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2,
        DeliveryAddressSuburb,
        DivisionCode,
        ExchangeRate,
        OrderNo,
        SalesOrderTypeCode,
        SalesRepresentativeCode,
        TaxTotal,
        Total,
        UserComment1,
        UserComment2,
        UserComment3,
        UserComment4,
        UserComment5,
        UserComment6,
        UserComment7,
        UserComment8,
        UserComment9,
        UserComment10,
        UserComment11,
        UserComment12,
        UserComment13,
        UserComment14,
        UserComment15,
        UserComment16,
        UserComment17,
        UserComment18,
        UserComment19,
        UserComment20,
      } = data;

      var payload = {
        TransactionFlag,
        OriginalInvoiceCode,
        BranchCode,
        ConsignmentNo,
        CurrencyCode,
        CustomerCode,
        CustomerDeliveryAddressLineNo,
        DateDue,
        DateIn,
        DeliveryAddressCompanyName,
        DeliveryAddressCountry,
        DeliveryAddressPostcode,
        DeliveryAddressState,
        DeliveryAddressStreetLine1,
        DeliveryAddressStreetLine2,
        DeliveryAddressSuburb,
        DivisionCode,
        ExchangeRate,
        OrderNo,
        SalesOrderTypeCode,
        SalesRepresentativeCode,
        TaxTotal,
        Total,
        UserComment1,
        UserComment2,
        UserComment3,
        UserComment4,
        UserComment5,
        UserComment6,
        UserComment7,
        UserComment8,
        UserComment9,
        UserComment10,
        UserComment11,
        UserComment12,
        UserComment13,
        UserComment14,
        UserComment15,
        UserComment16,
        UserComment17,
        UserComment18,
        UserComment19,
        UserComment20,
      };

      if (!payload.CustomerCode) payload.CustomerCode = this.baseView.id;
      payload.DateIn = data.DateIn
        ? new Date(data.DateIn).toSaveDate()
        : new Date().toSaveDate();

      payload.DateDue = payload.DateIn;

      for (const property in payload) {
        if (!payload[property]) payload[property] = "";
      }

      payload.ScreenName = "Customer Credit";

      return payload;
    },
    setDetailsPayload(data) {
      let {
        OriginalInvoiceLineNo,
        AddDiscPriceGroupCode,
        AddDiscPricingMethod,
        AddDiscPricingMethodValue,
        AddDiscSalesUMPrice,
        AddDiscStockUMPrice,
        // BatchStockTolerance,
        CalculatedDiscPcnt,
        CustomerProduct,
        DiscFXLineTotal,
        DiscLineTotal,
        FXLineTotal,
        IsCommentVisible,
        IsPrimeCostItem,
        ItemCode,
        ItemType,
        LineTotal,
        NetFXLineTotal,
        NetLineTotal,
        PriceGroupCode,
        PriceGroupSalesUMPrice,
        PriceGroupStockUMPrice,
        PricingMethod,
        PricingMethodValue,
        SalesUM,
        SalesUMConversion,
        SalesUMCost,
        SalesUMFXPrice,
        SalesUMInvoiceConversion,
        SalesUMIsVariable,
        SalesUMManufacturedCost,
        SalesUMNetFXPrice,
        SalesUMNetPrice,
        SalesUMPrice,
        SalesUMPromotionNetPrice,
        SalesUMQty,
        SalesUMStandardCost,
        SalesUMStandardPrice,
        Comment,
        DiscPcnt,
        StockUMNetPrice,
        StockUMPrice,
        StockUMQty,
        TaxCode,
        StockUM,
        StockUMFXPrice,
        StockUMStandardPrice,
        TaxableFXLineTotal,
        TaxableLineTotal,
        TaxFXLineTotal,
        TaxLineTotal,
        TaxRate,
        WetFreightAdjustment,
        WetFXFreightAdjustment,
        WetFXLineTotal,
        WetLineTotal,
        WetPcnt,
      } = data;

      var payload = {
        OriginalInvoiceLineNo,
        AddDiscPriceGroupCode,
        AddDiscPricingMethod,
        AddDiscPricingMethodValue,
        AddDiscSalesUMPrice,
        AddDiscStockUMPrice,
        // BatchStockTolerance,
        CalculatedDiscPcnt,
        CustomerProduct,
        DiscFXLineTotal,
        DiscLineTotal,
        FXLineTotal,
        IsCommentVisible,
        IsPrimeCostItem,
        ItemCode,
        ItemType,
        LineTotal,
        NetFXLineTotal,
        NetLineTotal,
        PriceGroupCode,
        PriceGroupSalesUMPrice,
        PriceGroupStockUMPrice,
        PricingMethod,
        PricingMethodValue,
        SalesUM,
        SalesUMConversion,
        SalesUMCost,
        SalesUMFXPrice,
        SalesUMInvoiceConversion,
        SalesUMIsVariable,
        SalesUMManufacturedCost,
        SalesUMNetFXPrice,
        SalesUMNetPrice,
        SalesUMPrice,
        SalesUMPromotionNetPrice,
        SalesUMQty,
        SalesUMStandardCost,
        SalesUMStandardPrice,
        Comment,
        DiscPcnt,
        StockUMNetPrice,
        StockUMPrice,
        StockUMQty,
        TaxCode,
        StockUM,
        StockUMFXPrice,
        StockUMStandardPrice,
        TaxableFXLineTotal,
        TaxableLineTotal,
        TaxFXLineTotal,
        TaxLineTotal,
        TaxRate,
        WetFreightAdjustment,
        WetFXFreightAdjustment,
        WetFXLineTotal,
        WetLineTotal,
        WetPcnt,
      };

      payload.ItemCode = data.Code.toString();
      payload.WetFreightAdjustment = 0;
      payload.WetFXFreightAdjustment = 0;

      for (const property in payload) {
        if (payload[property] == undefined) payload[property] = "";
      }

      payload.AddDiscPriceGroupCode = null;
      payload.AddDiscPricingMethod = null;
      payload.TaxRate = data.SalesTaxPcnt;

      return payload;
    },
    async setDateInValidation() {
      let startDateResult =
        await CustomerCreditService.getActiveAccountingPeriodStartDate();
      if (startDateResult) {
        let accountingPeriod = startDateResult.data.value[0];
        this.DateIn.min = new Date(accountingPeriod.StartDate.replace("Z", ""));
      }
      let endDateResult =
        await CustomerCreditService.getActiveAccountingPeriodEndDate();
      if (endDateResult) {
        let accountingPeriod = endDateResult.data.value[0];
        this.DateIn.max = new Date(accountingPeriod.EndDate.replace("Z", ""));
      }
    },
  },
};
</script>
